<!-- .departments -->
<div class="departments">
    <div class="departments__body" #bodyElement>
        <div class="departments__links-wrapper" style="max-height: 200px !important;" (mouseleave)="onMouseLeave()">
            <div class="departments__submenus-container"  #containerElement>
                <ng-container *ngFor="let item of categories">
                    <div
                        *ngIf="item.children"
                        class="departments__submenu departments__submenu--type--menu"
                        [ngClass]="{'departments__submenu--open': item === hoveredItem}"
                        #submenuElement
                    >
                        <app-header-menu [items]="item.children" (itemClick)="onSubItemClick()"></app-header-menu>
                    </div>
                </ng-container>
            </div>
            <ul class="departments__links" >
                <li
                    *ngFor="let item of categories"
                    class="departments__item"
                    [ngClass]="{
                        'departments__item--menu': item.children,
                        'departments__item--hover': item === hoveredItem
                    }"
                    (mouseenter)="onItemMouseEnter(item)"
                    #itemElement
                >

                    <ng-template #link>
                        {{ item.name }} 
                        <app-icon *ngIf="item.children" class="departments__item-arrow" name="arrow-rounded-right-6x9" size="6x9"></app-icon>
                    </ng-template>

                    <a class="departments__item-link" [routerLink]="'/shop/'+item.slug" (click)="onItemClick()" (appTouchClick)="onTouchClick($event, item)">
                        <ng-container  [ngTemplateOutlet]="link"></ng-container>
                    </a>
                    
                </li>
            </ul>
        </div>
    </div>

    <button class="departments__button"  (mouseenter)="toggle()" >
        <!-- <app-icon  class="departments__button-icon" name="menu-18x14" size="18x14"></app-icon> -->
        All CATEGORIES
        <app-icon class="departments__button-arrow" name="arrow-rounded-down-9x6" size="9x6"></app-icon>
    </button>
</div>
<!-- .departments / end -->
